import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import * as moment from 'moment';

@Component({
  selector: 'activity-card',
  templateUrl: './new-activity.component.html',
  styleUrls: ['./new-activity.component.css']
})
export class ActivityCardComponent implements OnInit {
  @Input() open: Boolean;
  @Input() data: any;
  @Output() close = new EventEmitter<boolean>();
  constructor(
    public translations: TranslationService
  ) { }

  ngOnChanges(changes) {

  }

  ngOnInit() {

  }

  getSequence(index){
    return index + 1;
  }

  formatTime(time) {
    if (time) {
      return moment(time).format('MMM DD, YYYY');
    }
    return null;
  }

  getTime(seconds) {
    let totalSeconds = seconds;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return hours + 'h ' + minutes + 'm ' + s + 's';
  }

  checkMap(da) {
    if(da.location){
      return true;
    }
    return false;
  }

  getLon(da){
    let parsed = JSON.parse(da.location);
    return parsed.long;
  }

  getLat(da){
    let parsed = JSON.parse(da.location);
    return parsed.lat;
  }

}
